var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("table", {
    ref: "table_container",
    staticClass: "generated-datatables",
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }